module.exports = __webpack_public_path__ + "assets/831d1522fecfaff72db76946fc1f4721.mp3";